var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.value
      ? _c(
          "div",
          [
            _c("avatar", {
              attrs: {
                image: _vm.value,
                cropped: _vm.cropped,
                size: "is-158-high",
              },
            }),
            _c(
              "button",
              {
                staticClass: "button",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.clearImage.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Remove photo")]
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "dc-dropzone" },
          [
            _vm.progress
              ? _c("progress-loader", { attrs: { value: _vm.progress } })
              : _vm._e(),
            _c("dropzone", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.value && !_vm.progress,
                  expression: "!value && !progress",
                },
              ],
              ref: "myVueDropzone",
              attrs: { id: "image-dropzone", options: _vm.options },
              on: {
                "vdropzone-error": _vm.uploadError,
                "vdropzone-error-multiple": _vm.uploadError,
                "vdropzone-success": _vm.success,
                "vdropzone-total-upload-progress": _vm.upload,
                "vdropzone-queue-complete": _vm.complete,
              },
            }),
          ],
          1
        ),
    _vm.errorMessage
      ? _c("div", { staticClass: "notification is-danger is-light" }, [
          _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
        ])
      : _vm._e(),
    _vm.showError
      ? _c("p", { staticClass: "help is-danger" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e(),
    _c("div", { staticClass: "my-preview vue-dropzone dropzone" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }